/**
 * DiskCapacityCloud component.
 */
import Cloud from '@shared/assets/images/png/cloud.png';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled disk capacity cloud image.
 */
const DiskCapacityCloud = styled.img``;

/**
 * Default props for the disk capacity cloud image.
 */
DiskCapacityCloud.defaultProps = {
  src: Cloud,
};

export default withImage(DiskCapacityCloud, false);
